import { Principle, LoginParams } from './src/Auth'
import Vue from 'vue'
import AuthPlugin from './src'
import store from '@/store'
import { toArray } from '@/utils/data'
import { localAuthorities } from '@/config/page/options'
import { scheduleRefreshToken } from '@/utils/oos'
// import arms from '@/arms'

const ssoLoginUrl = process.env.VUE_APP_SSO_LOGIN_URL

// 是否在开发环境开启 本地全量权限
const enabledLocalAuthorities = false
const isDev = process.env.NODE_ENV === 'development'
Vue.use(AuthPlugin, {
  single: process.env.VUE_APP_AUTH_MODE === 'S', // 是否单点登录模式
  principleLoader: function (): Promise<Principle> {
    const http = Vue.prototype.$http
    const all = [http.get('/backend/user/info'), http.get('/backend/user/rolesAndPerms'), http.get('/backend/item/getItems'), scheduleRefreshToken()]
    return Promise.all(all).then(([user, authority, dictionary2]: any) => {
      const dictionary = { ...dictionary2 }
      store.commit('dictionary/setItems', dictionary)
      const authorities = ((enabledLocalAuthorities && isDev) || Vue.prototype.$qiankun) ? localAuthorities : authority.perms
      return {
        user: {
          username: user.userNo,
          cname: user.name,
          ...user
        },
        roles: (authority.roles || []).map((v: any) => Object.assign({}, { roleCode: v.code, roleName: v.roleName })),
        authorities: toArray(authorities, cloneFn)
      }
    })

    function cloneFn(row: any, parent: any) {
      const pid = (parent && parent.pid) || ''
      const id = pid + '/' + row.code
      return {
        pid: id,
        id,
        code: row.code,
        label: row.label,
        parentId: pid || null,
        seq: row.seq,
        parent: parent,
        children: getOperateList(row.children)
      }
    }

    function getOperateList(list: any[] = []) {
      const _list: any[] = []
      list.map((item, index) => {
        if (item.type === 2) {
          _list.push(item.code)
        }
      })
      return _list
    }
  },
  logoutHandler: function (): Promise<string> {
    function getToken () {
      let cookie = ''
      if (window.document.cookie.indexOf('; token=') > -1) {
        cookie = 'token=' + window.document.cookie.split('; token=')[1].split(';')[0]
      } else if (window.document.cookie.indexOf('token=') > -1) {
        cookie = 'token=' + window.document.cookie.split('token=')[1].split(';')[0]
      } else {
        cookie = window.document.cookie
      }
      return cookie
    }
    const http = Vue.prototype.$http
    return http.get('/logout?' + getToken())
  },
  loginHandler: function (params: LoginParams): Promise<any> {
    const http = Vue.prototype.$http
    return http.post('/login', params)
  },
  ssoLoginUrl
})
